import { useNavigate } from 'react-router-dom';
import './Button.scss';
import { ReactNode } from 'react';

export type ButtonVariation = 'primary' | 'secondary' | 'outline';

const Button = ({
    variation,
    label,
    type,
    goTo,
    href,
} : {
    variation?: ButtonVariation;
    label: string;
    type?: 'submit' | 'reset' | 'button';
    goTo?: string;
    url?: string;
    href?: string;
}) => {

    const navigate = useNavigate();

    const Wrapper = ({children} : {
        children: ReactNode
    }) => (
        href ?
            <a href={href} target='_blank'>
                {children}
            </a> 
            :
            <>{children}</>
    )

    return (
        <Wrapper>
            <button 
                className={`button ${variation ?? 'primary'}`} 
                type={type ?? 'button'}
                {...(goTo && { onClick: () => navigate(goTo) })}
            >
                {label}
            </button>
        </Wrapper>
    )
}

export default Button